import axios from '../AxiosInterCeptor/AxiosInterCeptor'
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;

// The Combined Make & Model master: an OD company's Make & Model row paired with
// a TP company's row. The list answers `{ error, enabled, data }` — `enabled` is
// false while the backend's ENABLE_MULTI_PRODUCT_POLICY switch is off — and each
// item carries both rows (`odRow`, `tpRow`) plus `usable` and `issues[]`.

/** `query` is `{ isEnabled: true | false }` or nothing. Resolves to the whole answer, or undefined on a failure. */
const GetMakeModelCombo = (query = {}) => {
  const params = {};
  if (query.isEnabled === true || query.isEnabled === false) params.isEnabled = String(query.isEnabled);
  return axios
    .get(`${URL}/make-model-combo`, { params })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const PostMakeModelCombo = (recData) => {
  return axios
    .post(`${URL}/make-model-combo`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const UpdateMakeModelCombo = (_id, recData) => {
  return axios
    .put(`${URL}/make-model-combo/${_id}`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export { GetMakeModelCombo, PostMakeModelCombo, UpdateMakeModelCombo };
